export interface SaveThenOpenRequest {
  stepId?: string;
  confirm: () => boolean;
}

export interface CodeStepAiApi {
  canOpen: boolean;
  saveThenOpen: (request: SaveThenOpenRequest) => Promise<unknown>;
  saving: boolean;
  activeStepId: string | null;
}

export const isPersistedStepId = (stepId: string | null | undefined) =>
  Boolean(stepId) && !stepId!.startsWith('new');
